import { createStore, createHook, Action } from "react-sweet-state";

import { JiraIssue, Message, Store } from "./constants/types";
import { Steps, stepsLength } from "./constants/ui";

const initialState: Store = {
    step: Steps.CREATE_FIRST_STORY,
    isCreateButtonFocused: false,
    isDemoComplete: false,
    isTicketModalOpen: false,
    isDemoCompleteModalOpen: false,
    isDemoMessageVisible: true,
    todoCol: [] as Array<JiraIssue>,
    inProgressCol: [] as Array<JiraIssue>,
    doneCol: [] as Array<JiraIssue>,
    messages: {} as Message
};

const actions = {
    completeDemo:
        (): Action<Store> =>
        ({ setState }) => {
            setState({
                isDemoComplete: true,
                isDemoMessageVisible: false,
                step: undefined
            });
        },
    createIssue:
        (jiraIssueData: JiraIssue): Action<Store> =>
        ({ setState, getState }) => {
            const { todoCol } = getState();
            const todoColAppend = todoCol.concat([jiraIssueData]);
            setState({ todoCol: todoColAppend });
        },
    nextDemoStep:
        (): Action<Store> =>
        ({ setState, getState }) => {
            const { step } = getState();
            if (step === stepsLength - 1) {
                console.error(
                    "Error: cannot goto next message, currently on final message"
                );
                return;
            }
            setState({ step: step + 1, isDemoMessageVisible: true });
        },
    prevDemoStep:
        (): Action<Store> =>
        ({ setState, getState }) => {
            const { step } = getState();
            if (step === 0) {
                console.error(
                    "Error: cannot goto prev message, currently on first message"
                );
                return;
            }
            setState({ step: step - 1, isDemoMessageVisible: true });
        },
    restartDemo:
        (): Action<Store> =>
        ({ setState, getState }) => {
            const { messages, inProgressCol, doneCol } = getState();
            setState({
                ...initialState,
                messages,
                inProgressCol,
                doneCol,
                isCreateButtonFocused: true
            });
        },
    resetIncompleteDemo:
        (): Action<Store> =>
        ({ setState }) => {
            setState({
                step: Steps.CREATE_FIRST_STORY,
                isDemoMessageVisible: true
            });
        },
    setTodoCol:
        (colInfo: Array<JiraIssue>): Action<Store> =>
        ({ setState }) => {
            setState({ todoCol: colInfo });
        },
    setDoneCol:
        (colInfo: Array<JiraIssue>): Action<Store> =>
        ({ setState }) => {
            setState({ doneCol: colInfo });
        },
    setInProgressCol:
        (colInfo: Array<JiraIssue>): Action<Store> =>
        ({ setState }) => {
            setState({ inProgressCol: colInfo });
        },
    setDemoStep:
        (step: Steps): Action<Store> =>
        ({ setState }) => {
            setState({ step });
        },
    setMessages:
        (messages: Message): Action<Store> =>
        ({ setState }) => {
            setState({ messages });
        },
    toggleCompleteDemoModalOpen:
        (): Action<Store> =>
        ({ setState, getState }) => {
            const { isDemoCompleteModalOpen: prevStateIsModalOpen } =
                getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isDemoCompleteModalOpen: !prevStateIsModalOpen
            });
        },
    setSpotlightVisibility:
        (visible: boolean): Action<Store> =>
        ({ setState }) => {
            setState({ isDemoMessageVisible: visible });
        },
    toggleTicketModalOpen:
        (): Action<Store> =>
        ({ setState, getState }) => {
            const { isTicketModalOpen: prevStateIsModalOpen } = getState();
            setState({
                isCreateButtonFocused: prevStateIsModalOpen,
                isTicketModalOpen: !prevStateIsModalOpen
            });
        }
};

const InteractiveBoardStore = createStore({
    initialState,
    actions,
    name: "jsw-interactive-board-store"
});

const getMessages = (state: Store) => state.messages;
export const useMessages = createHook(InteractiveBoardStore, {
    selector: getMessages
});
export const useInteractiveBoardStore = createHook(InteractiveBoardStore);
